import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Button,
  Checkbox,
  FormGroup,
  FormControlLabel
} from '@material-ui/core';
import AlertIcon from '@material-ui/icons/Error';
import { withLocal } from '../common/LocaleProvider/LocaleProvider';
import routes from '../../constants/routes';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 68px)',
      justifyContent: 'space-between'
    }
  },
  header: {
    color: theme.palette.primary.main,
    fontFamily: 'auto',
    fontSize: '24px',
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      marginRight: '8px'
    }
  },
  content: {
    marginBottom: '64px'
  },
  checkbox: {
    color: theme.palette.primary.main
  }
}));

const PreScreenInstructions = ({ history, locale }) => {
  const classes = useStyles();
  const [doNotShowChecked, setDoNotShowChecked] = useState(false);
  const [haveReadChecked, setHaveReadChecked] = useState(false);

  const handleContinue = () => {
    history.push({
      pathname: routes.CREATE_ACCOUNT,
      state: { doNotShowInstructions: doNotShowChecked }
    });
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.content}>
          <h1 className={classes.header}>
            <AlertIcon />
            {locale.pre_screen_instructions.alert}
          </h1>
          <p>{locale.pre_screen_instructions.instruc_1}</p>
          <p>{locale.pre_screen_instructions.instruc_2}</p>
          <p>{locale.pre_screen_instructions.instruc_3}</p>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  name="do-not-show-intruc-check"
                  className={classes.checkbox}
                  color="primary"
                  checked={doNotShowChecked}
                  onChange={() => setDoNotShowChecked(!doNotShowChecked)}
                />
              }
              label={locale.pre_screen_instructions.do_not_show_label}
            />
          </FormGroup>
        </div>
        <div>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  name="i-have-read-check"
                  className={classes.checkbox}
                  color="primary"
                  checked={haveReadChecked}
                  onChange={() => setHaveReadChecked(!haveReadChecked)}
                />
              }
              label={locale.pre_screen_instructions.have_read_label}
            />
          </FormGroup>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleContinue()}
            disabled={!haveReadChecked}
          >
            {locale.button_labels.continue}
          </Button>
        </div>
      </Paper>
    </div>
  );
};

export default withLocal(PreScreenInstructions);
